module.exports = __webpack_public_path__ + "static/media/AppTitleLogo.babd9cd3.png";